export default {
  props: {
    form: {
      type: Object,
      required: true
    },
    activeLang: String
  },
  model: {
    prop: 'form',
    event: 'next'
  },
  mounted () {
    this.$v2.blurredForm = false
  },
  methods: {
    sendForm () {
      if (!this.$v2.forceValidateForm()) return
      this.$emit('next', this.form)
    }
  }
}
